module.exports = __webpack_public_path__ + "static/img/3联展.38ce5ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/3联展.jpg
// module id = YiC4
// module chunks = 1